import { Box, Typography } from "@mui/material";

export default function ActionHeader({ number, label, accentColor }) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, width: "100%" }}>
      <Box
        sx={{
          flexShrink: 0,
          width: 28,
          height: 28,
          borderRadius: "50%",
          border: `2px solid ${accentColor}`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          variant="number4"
          sx={{ color: accentColor, fontWeight: 700, fontSize: "0.75rem", lineHeight: 1 }}
        >
          {number}
        </Typography>
      </Box>
      <Typography variant="h6" fontWeight={700}>
        {label}
      </Typography>
    </Box>
  );
}
